import { render, staticRenderFns } from "./message-patterns-readonly.vue?vue&type=template&id=15d5748a&scoped=true&"
import script from "./message-patterns-readonly.vue?vue&type=script&lang=js&"
export * from "./message-patterns-readonly.vue?vue&type=script&lang=js&"
import style0 from "./message-patterns-readonly.vue?vue&type=style&index=0&id=15d5748a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d5748a",
  null
  
)

export default component.exports